export default [
    0xff0100,
    0xff1900,
    0xff3000,
    0xfd5105,
    0xfe6d02,
    0xff8700,
    0xfda307,
    0xffbc04,
    0xffd803,
    0xfff208,

    0xefff00,
    0xd0ff00,
    0xb2fc0f,
    0xa3fb04,
    0x79ff00,
    0x5eff00,
    0x54ff0e,
    0x35f41f,
    0x21f905,
    0x00ff03,

    0x00fe30,
    0x02fd44,
    0x06ff63,
    0x0cf77f,
    0x0dfa92,
    0x05fcad,
    0x07facc,
    0x0afce1,
    0x05faff,
    0x10d8ff,

    0x08c5fd,
    0x09c3fe,
    0x01aefd,
    0x0291f9,
    0x0674f5,
    0x0958f6,
    0x023efd,
    0x0026ff,
    0x0008ff,
    0x1500f8,

    0x4900ff,
    0x6001fe,
    0x8400ef,
    0x9e00fe,
    0xb301fc,
    0xd202f7,
    0xf800ff,
    0xff00f3,
    0xff00e2,
    0xff00c7
];
